import {DateTime} from 'luxon';

export function toIsoDateHelper(date: DateTime | null): string | null {
  return date?.toISODate() ?? null;
}
